import { FC } from 'react';

import { Content } from 'shared/components/Content';

import { MotivationContainer } from '../MotivationContainer';
import { Advantages } from '../../components/Advantages';

export const ContentContainer: FC = () => {
  return (
    <Content
      motivationTop={<MotivationContainer />}
      advantages={<Advantages />}
      motivationBottom={<MotivationContainer isBottom />}
    />
  );
};
